import {
  GET_ALL_MEDICAL_HISTORY,
  GET_ALL_MEDICAL_HISTORY_SUCCESS,
  GET_MEDICAL_DRAFT,
  GET_MEDICAL_DRAFT_SUCCESS,
  GET_MEDICAL_DRAFT_FAILURE,
} from '../storeTypes';

export const ActionGetAllMedicalHistory = payload => {
  return {
    type: GET_ALL_MEDICAL_HISTORY,
    payload,
  };
};

export const ActionGetAllMedicalHistorySuccess = payload => {
  return {
    type: GET_ALL_MEDICAL_HISTORY_SUCCESS,
    payload,
  };
};

export const ActionGetMedicalDraft = payload => {
  return {
    type: GET_MEDICAL_DRAFT,
    payload,
  };
};

export const ActionGetMedicalDraftSuccess = payload => {
  return {
    type: GET_MEDICAL_DRAFT_SUCCESS,
    payload,
  };
};

export const ActionGetMedicalDraftFailure = payload => {
  return {
    type: GET_MEDICAL_DRAFT_FAILURE,
    payload,
  };
};
